
export default {
  timeBasedRoute: {
    morning: 'Morgens',
    noon: 'Mittags',
    afternoon: 'Nachmittags',
    evening: 'Abends',
    timeOfDay: 'Tageszeit',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    month: 'Monat'
  }
}
